/* eslint jsx-a11y/aria-role: 0 */
import React, { Component } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactSVG from 'react-svg';
import LayoutType from '../../const/layout_type';

import './style.css';
const styles = {
  navIcon: {width:'50px', height: '50px'}
}

const PRODUCT_IMAGE_HEIGHT_PX = 400;
const PRODUCT_IMAGE_WIDTH_PX = 400;

class ProductImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRingSpinner: this.props.imageUrl ? true : false,
    }
  }

  onImgLoaded = () => {
      this.setState({
        isRingSpinner: false
      })
  }

  getUrl({ imageUrl } = this.props) {
    if (!imageUrl) {
      return this.getPlaceHolder();
    }

    const baseImageUrl = window.location.href.startsWith('https://test')
      ? 'https://img-ci.treez.io'
      : 'https://img.treez.io';

    return `${baseImageUrl}/${imageUrl}?size=400`;
  }

  getImage = ({ image }) => {
    const {
      isRingSpinner
    } = this.state;

    const {
      imageUrl,
      scrollPosition
    } = this.props;
    const isImage = !!imageUrl;

    return <div style={isRingSpinner ? {visibility: 'hidden'} : {visibility: 'visible'}} className={isImage ? "item-photo" : "img-error"}>
      <LazyLoadImage
        afterLoad={this.onImgLoaded}
        alt={''}
        height={image.height}
        width={PRODUCT_IMAGE_WIDTH_PX} 
        src={image.src}
        delayTime={800}
        scrollPosition={scrollPosition}
      />
    </div>
  }
  
  getPlaceHolder() {
    if (this.props.noProductImage) return this.props.noProductImage;
    return process.env.PUBLIC_URL + '/assets/img/placeholder-kiosk.svg';
  }

  isPlaceholder() {
    return !this.props.imageUrl;
  }

  getHeight() {
    return this.isPlaceholder() ? 'auto' : 400;
  }

  getClassNames = () => {
    const classNames = "img-wrapper product-image-wrapper";
    const { layoutType } = this.props;

    return `${classNames} ${(layoutType && (layoutType === LayoutType.GRID ? 'grid' : 'list')) || ''}`;
  }

  render() {
    return (
      <div className={this.getClassNames()}>
        { this.state.isRingSpinner && <div className="item-spinner"><img alt="spinner" src={ process.env.PUBLIC_URL + "/assets/img/ring.svg"} /></div> }
           { this.getImage({
              image: { 
                height: this.getHeight(),
                width: 400,
                src: this.getUrl(), 
                alt:'',
              }
             })
           }
      			{ this.props.hasPrev && 
              <div onClick={this.props.handlePrevProduct} role="prev_product">
                <ReactSVG style={styles.navIcon} path={require('./icons/Icon_Back.svg')}/>
              </div>
            }
						{ this.props.hasNext && 
              <div onClick={this.props.handleNextProduct} role="next_product">
                <ReactSVG style={styles.navIcon} path={require('./icons/Icon_Next.svg')}/>
              </div>
            }

      </div>
    );
  }
}

export default ProductImage;



// WEBPACK FOOTER //
// ./src/components/ProductImage/ProductImage.jsx